"use client"

import React, { useEffect, useRef, useState } from "react"
import styles from './styles.module.scss'
import ScrollContainer from "react-indiana-drag-scroll";
import SvgArrowLeft from '@/src/assets/svgs/collection/arrow-left.svg'
import SvgArrowRight from '@/src/assets/svgs/collection/arrow-right.svg'

interface Props {
    children: React.ReactNode
    className?: string
    removePadding?: boolean
    removeArrows?: boolean
    id?: string
}

export default function ScrollContent(props: Props) {
    const scrollContainer = useRef(typeof window !== 'undefined' ? document.createElement("div") : null);
    const [isLeft, setLeft] = useState(false);
    const [isRight, setRight] = useState(false);

    const leftBtn = isLeft ? (
        <span className={styles.arrowBack} onClick={(e) => navigateArrowsSegment(e, "L")}>
            <SvgArrowLeft className={styles.svgArrowBack} />
        </span>
    ) : null;

    const rightBtn = isRight ? (
        <span className={styles.arrowForward} onClick={(e) => navigateArrowsSegment(e, "R")}>
            <SvgArrowRight className={styles.svgArrowForward} />
        </span>
    ) : null;

    function navigateArrowsSegment(e: any, side: any): void {
        const { clientWidth, scrollLeft }: any = scrollContainer.current;
        scrollContainer.current!.scrollTo({
            left:
                side === "R"
                    ? scrollLeft + clientWidth / 2
                    : scrollLeft - clientWidth / 2,
            behavior: "smooth"
        });
    };

    function removeArrowOnInit() {
        if (scrollContainer.current) {
            const { clientWidth, scrollWidth }: HTMLDivElement = scrollContainer.current;

            if (scrollWidth > clientWidth)
                setRight(true)
        }

    }

    useEffect(() => {
        removeArrowOnInit()

        if (scrollContainer.current) {
            const el = scrollContainer.current;

            el.onscroll = () => {
                const { clientWidth, scrollLeft, scrollWidth } = el;
                setLeft(scrollLeft > 0);
                setRight(scrollLeft + clientWidth !== scrollWidth);
            };

            el.id = props.id ?? ''
        }
    }, [])

    return (
        <div className={styles.container} style={props.removePadding ? { padding: 0 } : {}}>
            {!props.removeArrows && leftBtn}
            <ScrollContainer vertical={false} innerRef={scrollContainer} className={`${styles.scrollContent} ${props.className ?? ""}`}>
                {props.children}
            </ScrollContainer>
            {!props.removeArrows && rightBtn}
        </div>
    );
}
